"use strict";


    let scrolledTop = window.pageYOffset || document.documentElement.scrollTop,
        sectionBreakpoints = [0],
        blockActions = false,
        formInited = false;

    function keyboardText() {
        setTimeout(function() {
            let textElem = document.querySelectorAll('.keyboardText');

            if( textElem ) {
                for( let i = 0, count = textElem.length; i < count; i += 1 ) {
                    let text = textElem[i].getAttribute('data-text'),
                        textArray = text.split(''),
                        position = offset(textElem[i]).top;

                    window.dispatchEvent(new CustomEvent('scroll'));
                    window.addEventListener('load', function() {
                        typeLetters();
                    });
                    window.addEventListener('scroll', function() {
                        typeLetters();
                    });

                    function typeLetters() {
                        if(scrolledTop < position && scrolledTop + window.innerHeight > position && !textElem[i].classList.contains('typed') ) {
                            textElem[i].classList.add('typed');

                            setTimeout(function() {
                                let counter = 0;
                                let putLetters = setInterval(function() {
                                    textElem[i].innerHTML += textArray[counter];

                                    if( counter == textArray.length - 1 ) {
                                        clearInterval(putLetters);
                                    } else {
                                        counter += 1;
                                    }

                                }, 50);
                            }, 1400);
                        }
                    }

                }
            }
        }, 500);
    }

    function offset(el) {
        var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }

    function clickArrowDown() {
        let btn = document.querySelector('.goSectionDown');

        if(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                TweenLite.to(window, 1, {scrollTo: sectionBreakpoints[1] });
            });
        }
    }
    function clickArrowUp() {
        let btn = document.querySelector('.toTop');

        if(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                TweenLite.to(window, 1, {scrollTo: 0 });
            });
        }
    }

    function clickOnSplash() {
        let splash = document.querySelector('.splash'),
            section = document.querySelector('#underSplash');

        if(splash) {
            let position = offset(section).top;
            splash.addEventListener('click', function() {
                TweenLite.to(window, 1, {scrollTo: position });
            })
        }
    }

    function initSectionBreakpoints() {
        setTimeout(function() {
            let sections = document.querySelectorAll('[data-scrollElem="true"]');

            if( sections ) {
                for( let i = 0, count = sections.length; i < count; i++ ) {
                    sectionBreakpoints.push(offset(sections[i]).top);
                }
            }
        }, 300);
    }

    function scrollBySection(direction) {
        let body = document.querySelector('body');
        let scrollSection = document.querySelector('[data-sectionScroll="true"]');

        if( body.classList.contains('desktop') && scrollSection && !blockActions ) {
            let nextSectionPosition = '';
            blockActions = true;

            if( direction == 'down' ) {
                for( let i = 0, count = sectionBreakpoints.length; i < count; i++ ) {
                    if( sectionBreakpoints[i] > scrolledTop + 5 ) {
                        nextSectionPosition = sectionBreakpoints[i];
                        break;
                    }
                }
            } else {
                for( let i = sectionBreakpoints.length - 1; i >= 0; i-- ) {
                    if( sectionBreakpoints[i] < scrolledTop ) {
                        nextSectionPosition = sectionBreakpoints[i];
                        break;
                    }
                }
            }

            TweenLite.to(window, 0.7, {scrollTo:nextSectionPosition});
            setTimeout(function() {
                blockActions = false;
            }, 1000);
        }
    }

    function trimJobTitle() {
        let titles = document.querySelectorAll('.job-title a');

        if( titles ) {
            for( let i = 0, count = titles.length; i < count; i++ ) {
                let elem = titles[i],
                    string = elem.innerHTML,
                    part = string.substring(10, string.length),
                    wrapped = string.replace(part, '<span class="trimmed">' + part + '</span>');
                    elem.innerHTML = wrapped;
            }
        }
    }

    function removeLoader() {
        let loader = document.querySelector('.loaderWrapper');

        if( loader ) {
            setTimeout(function() {
                loader.style.pointerEvents = 'none';
                TweenLite.to(loader, .5, {opacity: 0});
            }, 1000);
        }
    }

    function playVideoOnHover() {
        let vids = document.querySelectorAll('.work-tile-video');

        if( vids ) {
            for (let i = 0, count = vids.length; i < count; i++) {
              vids[i].addEventListener( 'mouseover', function(e) {
                vids[i].play();
              });
              vids[i].addEventListener( 'mouseout', function(e) {
                vids[i].pause();
              });
            }
        }
    }

    function aos() {
        setTimeout(function() {
            AOS.init({
                throttleDelay: 250,
                once: false,
                duration: 900,
                offset: 100,
                once: true
            });
        }, 1000);
    }

    function contactSend() {
        if( !formInited ) {
            console.log('event listener');
            document.addEventListener( 'wpcf7mailsent', function( event ) {
                let info = document.querySelector('.contactSend');
                console.log('contact form sent');

                info.classList.add('active');
                TweenMax.to(info, 0.7, { opacity: 1 });
            }, false );

            formInited = true;
        }
    }

    function closeSend() {
        let btn = document.querySelector('#closeSend');
        let info = document.querySelector('.contactSend');

        if( btn ) {
            btn.addEventListener('click', function() {
                TweenMax.to(info, 0.7, { opacity: 0 });
                info.classList.remove('active');
            });
        }
    }

    function detectScroll() {
        let elem = document.querySelector('[data-detectScroll="true"]');

        if( elem ) {
            let elemStart = offset(elem).top,
                elemHeight = elem.clientHeight,
                elemEnd = elemStart + elemHeight,
                scrollIndicator = document.querySelector('.scrollProgress'),
                scrollWrapper = document.querySelector('.scrollIndicator');
                moveIndicator(scrolledTop, elemStart, elemHeight, scrollIndicator);

            window.addEventListener('scroll', function() {
                moveIndicator(scrolledTop, elemStart, elemHeight, scrollIndicator);

                if(scrolledTop >= elemStart - window.innerHeight / 2 && scrolledTop <= elemEnd - window.innerHeight / 2) {
                    scrollWrapper.style.opacity = 1;
                } else {
                    scrollWrapper.style.opacity = 0;
                }
            });
        }
    }

    function moveIndicator(scrolledTop, elemStart, elemHeight, scrollIndicator) {
        let howLongOfElemHeightSCrolled = scrolledTop - elemStart + window.innerHeight;
        let percent = Math.ceil( (howLongOfElemHeightSCrolled / elemHeight) * 100 );
        percent = percent + '%';

        scrollIndicator.style.width = percent;
    }

    function projectsSlider() {
        let body = document.querySelector('body');
        let sliderContainer = document.querySelector('.desktopProjectSlider');
        let worksSliderContainer = document.querySelector('.ourWorksSlider');

        if(body.classList.contains('desktop') && sliderContainer) {
            var slider = tns({
                container: '.desktopProjectSlider',
                items: 4,
                slideBy: 'page',
                autoplay: false,
                autoplayButtonOutput: false,
                nav: false,
                gutter: 14,
                slideBy: 1
            });
        }

        if(body.classList.contains('desktop') && worksSliderContainer) {
            var slider = tns({
                container: '.ourWorksSlider',
                items: 6,
                slideBy: 'page',
                autoplay: false,
                autoplayButtonOutput: false,
                nav: false,
                gutter: 14,
                slideBy: 1
            });
        }
    }

    function getPage(url, pushNewState) {
        let xhr = new XMLHttpRequest(),
            cover = document.querySelector('.pageLoad_cover'),
            titleWrap = document.querySelector('title'),
            contentWrapper = document.querySelector('.siteContainer'),
            body = document.querySelector('body'),
            additionalClass = body.classList.contains('desktop') ? 'desktop' : 'mobile';

        TweenMax.to(cover, 0.7, {x: '0%'});

        xhr.open('GET', url);
        xhr.onload = function() {
            if (xhr.status === 200) {
                let response = xhr.response,
                    title = response.title,
                    content = response.querySelector('.siteContainer').innerHTML,
                    newBody = response.querySelector('body');

                scrolledTop = 0;
                titleWrap.innerHTML = title;
                body.setAttribute('class', newBody.getAttribute('class'));
                body.classList.add(additionalClass);
                contentWrapper.innerHTML = content;
                sectionBreakpoints = [0];
                setTimeout(function() {
                    TweenLite.to(window, 0.1, {scrollTo: 0 });
                    initFunctions();
                }, 200);

                setTimeout(function() {
                    TweenMax.to(cover, 0.5, {x: '-100%'});
                    // TweenMax.to(cover, 0, {opacity: 0});
                    TweenMax.to(cover, 0, {x: '100%', delay: 0.6});
                    // TweenMax.to(cover, 0.1, {opacity: '100%'});
                }, 1200);

                let stateObj = {
                    page: titleWrap.innerHTML,
                };

                var wWidth = window.innerWidth;

                setTimeout(function() {
                    if( wWidth >= 1023 ) {
                        var video = document.querySelector('.splashVideo');

                        if( video ) {
                            video.style.display = 'block';
                            video.play();
                        }
                    }

                    var script = document.createElement('script');
                    script.setAttribute('src', php_vars.templates_dir + '/js/custom.js');
                    contentWrapper.appendChild(script);
                }, 100);


                if( pushNewState ) {
                    history.pushState(stateObj, titleWrap.innerHTML, url);
                }

                wpcf7.initForm(document.querySelector('.wpcf7-form'));
            }
            else {
                console.log('error', xhr.status);
            }
        };
        xhr.responseType = "document";
        xhr.send();
    }

    function initLinkAjaxAction() {
        let link = document.querySelectorAll('a');

        if( link ) {
            for( let i = 0, count = link.length; i < count; i += 1 ) {
                link[i].addEventListener('click', function(e) {

                    if( !this.classList.contains('local') && !this.classList.contains('external') && !this.classList.contains('swipebox') ) {
                        e.preventDefault();
                        getPage(this.getAttribute('href'), true);
                    }
                })
            }
        }
    }

    function initMap() {
        let container = document.querySelector('#map');


        if( container ) {
            var lat = container.getAttribute('data-lat');
            var lng = container.getAttribute('data-lng');
            var mapOptions = {
                zoom: 17,
                center: new google.maps.LatLng(lat, lng),
                styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
            };
            var markerIcon = php_vars.templates_dir + '/dist/img/icon_marker.png';

            var map = new google.maps.Map(container, mapOptions);

            // Let's also add a marker while we're at it
            var maarker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: markerIcon
            });
        }
    }

    function menuToggle() {
        const body = document.querySelector('body.home');
        const menuElem = document.querySelector('.topBar');

        let burger = document.querySelector('.menu-toggle'),
            topBar = document.querySelector('.topBar');

        burger.addEventListener('click', function() {
            if( !burger.classList.contains('is-active') ) {
                burger.classList.add('is-active');
                topBar.classList.add('is-opened');
            } else {
                burger.classList.remove('is-active');
                topBar.classList.remove('is-opened');
            }
        });

        if(body) {
            setTimeout(function() {
                body.classList.add('scrolled');
                menuElem.classList.add('is-scrolled');
            }, 3500);
        }

    }

    function setMenuScrolledClass() {
        const menuContainer = document.querySelector('.topBar');
        const body = document.querySelector('body');

        if( scrolledTop > 150 ) {
            menuContainer.classList.add('is-scrolled');
            body.classList.add('scrolled');
        }
    }

    function initFunctions() {
        window.dispatchEvent(new CustomEvent('scroll'));
        scrolledTop = window.pageYOffset || document.documentElement.scrollTop;
        keyboardText();
        clickArrowDown();
        initSectionBreakpoints();
        clickArrowUp();
        trimJobTitle();
        removeLoader();
        clickOnSplash();
        playVideoOnHover();
        aos();
        contactSend();
        closeSend();
        detectScroll();
        projectsSlider();
        initLinkAjaxAction();
        initMap();
        menuToggle();
    }

    window.addEventListener('load', function() {
        initFunctions();

        window.onpopstate = function(event) {
            setTimeout(function() {
                getPage(window.location.href, false);
            }, 200);
        }
    });

    window.addEventListener('scroll', function() {
        scrolledTop = window.pageYOffset || document.documentElement.scrollTop;
        setMenuScrolledClass();
    });

    window.addEventListener('wheel', function(e) {
      if (e.deltaY < 0) {
        scrollBySection('up');
      }
      if (e.deltaY > 0) {
        scrollBySection('down');
      }
    });

    document.onkeydown = function(e) {
        if( e.keyCode == 38 || e.keyCode == 33 ) {
            scrollBySection('up');
        }

        if( e.keyCode == 40 || e.keyCode || 34 || e.keyCode == 32 ) {
            scrollBySection('up');
        }
    }


//////////////////
// WEBPACK FOOTER
// ./js/script.js
// module id = 2
// module chunks = 0